import { MutableRefObject, useEffect, useRef } from 'react';

export default function useIsMounted(): MutableRefObject<boolean> {
  const isMounted = useRef(true);

  useEffect(() => {
    return (): void => {
      isMounted.current = false;
    };
  }, []);

  return isMounted;
}
